import { useEffect } from 'react';
import { brandConfig } from '../config/brandconfig';

/**
 * SEO头部组件 - 动态设置页面标题和描述
 * 使用品牌配置文件中的信息
 */
const SEOHead = ({ title, description }) => {
  useEffect(() => {
    // 设置页面标题
    const pageTitle = title 
      ? `${title} - ${brandConfig.brand.name}` 
      : `${brandConfig.brand.name} - ${brandConfig.brand.slogan}`;
    document.title = pageTitle;

    // 设置页面描述
    const pageDescription = description || brandConfig.brand.description;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', pageDescription);
    }

    // 设置主题色
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) {
      themeColorMeta.setAttribute('content', brandConfig.theme.primary[500]);
    }
  }, [title, description]);

  return null; // 这个组件不渲染任何内容
};

export default SEOHead;